import React from 'react';

import { fade } from '@material-ui/core/styles';
import styled from '@material-ui/core/styles/styled';
import { useTranslation } from 'react-i18next';

import { colorsPalette } from '../../../theme';
import { COURSE_STATUSES } from '../../../types';

const ProgressBar = ({
  status = COURSE_STATUSES.NOT_STARTED,
  progress = 0,
}: {
  status?: COURSE_STATUSES | null;
  progress?: number;
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <Status>
        {status === COURSE_STATUSES.NOT_STARTED && t('common.notStarted')}
        {status === COURSE_STATUSES.COMPLETED && t('common.completed')}
        {status === COURSE_STATUSES.STARTED && t('common.inProgress')}
      </Status>
      <Bar progress={status === COURSE_STATUSES.NOT_STARTED ? 0 : progress} />
    </div>
  );
};

export default ProgressBar;

const Bar = styled('div')(({ progress }: { progress: number }) => ({
  position: 'relative',
  width: '100%',
  height: 5,
  borderRadius: 10,
  background: fade(colorsPalette.blue, 0.3),
  overflow: 'hidden',
  '&:after': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    width: `${progress || 0}%`,
    height: '100%',
    background: colorsPalette.blue,
  },
}));
const Status = styled('span')({
  display: 'block',
  padding: '0 24px 10px',
  textAlign: 'right',
  fontWeight: 700,
  textTransform: 'uppercase',
  color: fade(colorsPalette.blue, 0.3),
});
